import type { RotasDoModulo } from '@/app/rotas';

import { ReportsPage } from './ReportsPage';

/**
 * Relatorios (P-BI-1): o item "/bi" do menu abre o Resumo executivo, e cada pagina
 * tem o proprio endereco, como a pagina do relatorio do OnPoint.
 */
export const rotas: RotasDoModulo = {
  menu: { '/bi': ReportsPage },
  moldura: [{ path: '/bi/:pageKey', element: <ReportsPage /> }],
};
